$(function(){
$(".flip").click(function(){
$(".panel-slide").slideToggle("slow");
$(".xs1").toggle();
$(".xs2").toggle();
});});
